<div class="common-popup-container add-user-account-popup doc-upload-popup-wrapper">
    <h3 class="title mb-0">{{ 'QUOTATIONNEW_SUMMARY.VIEW_SUPPORTING_DOCS' | translate }}</h3>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center my-4">
        <i class="fa fa-refresh fa-spin fa-2x" aria-hidden="true"></i>
        <p class="mt-2">{{ 'QUOTATIONNEW_SUMMARY.LOADING' | translate }}</p>
    </div>

    <!-- Main Content -->
    <div *ngIf="!isLoading">

        <!-- Existing Documents Section -->
        <div class="my-input-group mt-3" *ngIf="existingDocuments.length > 0">
            <label>{{ 'QUOTATIONNEW_SUMMARY.EXISTING_DOCUMENTS' | translate }} ({{ existingDocuments.length }})</label>

            <div class="file-attachment-container mt-2">
                <div class="file-attached-container mt-2" *ngFor="let doc of existingDocuments">
                    <div class="attachment flex-one justify-content-between m-0">
                        <div class="d-flex align-items-center mr-2" (click)="downloadDocument(doc)"
                            style="cursor: pointer;">
                           <img [src]="getImageIcon(doc)">
                            <div class="d-flex flex-column">
                                <span class="file-name doc-name">{{ doc.fileName }}</span>
                                <span class="file-size text-muted small">{{ doc.createdOn | date: 'MMM dd, yyyy'
                                    }}</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <img src="assets/images/thick-download-icon.svg" class="action-icon mr-2"
                                (click)="downloadDocument(doc)" style="cursor: pointer; width: 20px;">
                            <img src="assets/images/new-set/close.svg" class="close-icon"
                                style="width: 16px; cursor: pointer;" (click)="markForDeletion(doc.id)">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State for Existing Documents -->
        <div class="empty-state mt-3" *ngIf="existingDocuments.length === 0 && newDocuments.length === 0">
            <img src="assets/images/new-set/empty-folder.svg" class="empty-icon" *ngIf="false">
            <p class="text-muted">{{ 'QUOTATIONNEW_SUMMARY.NO_SUPPORTING_DOCS' | translate }}</p>
        </div>

        <!-- Upload New Documents Section -->
        <div class="my-input-group mt-3">
            <label>
                {{ 'QUOTATIONNEW_SUMMARY.UPLOAD_NEW_DOCS' | translate }}
                <div data-tooltip="Upload new supporting documents (PDF, DOC, DOCX, XLS, XLSX, JPG, PNG). Max size: 10MB per file."
                    class="comment-badge rounded common-tooltip-table fix-width d-inline ml-0">
                    <img src="assets/images/new-set/thick-info-gray.svg">
                </div>
            </label>

            <!-- File Upload Area -->
            <div class="file-upload-container upload-files-container" (click)="fileInput.click()"
                style="cursor: pointer;">
                <img src="assets/images/thin-gray-upload.svg" class="upload-icon">
                <div class="upload-here ml-2">
                    <p class="upload-content drop-file">
                        <span>{{ 'QUOTATIONNEW_SUMMARY.BROWSE_FILE' | translate }}</span>
                    </p>
                </div>
            </div>
            <input #fileInput type="file" multiple (change)="onFileSelected($event)"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png" hidden>

            <!-- Display New Documents to Upload -->
            <div class="file-attachment-container mt-2" *ngIf="newDocuments.length > 0">
                <div class="file-attached-container mt-2" *ngFor="let doc of newDocuments; let idx = index">
                    <div class="attachment flex-one justify-content-between m-0">
                        <div class="d-flex align-items-center mr-2">
                       <img [src]="getImageIcon(doc)">                            
                                 <div class="d-flex flex-column">
                                <span class="file-name doc-name">{{ doc.fileName }}</span>
                                <span class="file-size text-muted small">{{ getFileSize(doc.fileSize) }}</span>
                            </div>
                        </div>
                        <img src="assets/images/new-set/close.svg" class="close-icon"
                            style="width: 16px; cursor: pointer;" (click)="removeNewDocument(idx)">
                    </div>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="column text-right cta-container mt-4">
            <button class="secondary-cta link cancel" [disabled]="isSaving" (click)="cancel()">
                {{ 'QUOTATIONNEW_SUMMARY.CANCEL' | translate }}
            </button>
            <button class="primary-cta"
                [disabled]="isSaving || (newDocuments.length === 0 && documentsToDelete.length === 0)"
                (click)="saveDocuments()">
                {{ 'QUOTATIONNEW_SUMMARY.SAVE' | translate }}
                <span *ngIf="isSaving">
                    <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                </span>
            </button>
        </div>

        <!-- Upload Progress Indicator -->
        <div *ngIf="isUploading" class="text-center mt-3">
            <i class="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
            <p class="mt-2">{{ 'QUOTATIONNEW_SUMMARY.UPLOADING_FILES' | translate }}</p>
        </div>
    </div>
</div>


<div class="loader-overlay" *ngIf="isSaving">
    <div class="loader-container">
        <img src="assets/images/reload.svg" alt="">
        <span>{{'COMMON.LBL_LOADER' | translate}}</span>
    </div>
</div>